import React, { useState } from 'react';
import { DownOutlined } from '@ant-design/icons';

interface CardSectionProps {
  title: React.ReactNode;
  defaultOpen?: boolean;
  extra?: React.ReactNode;
  children: React.ReactNode;
}

const CardSection: React.FC<CardSectionProps> = ({ title, defaultOpen = true, extra, children }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div style={{ marginBottom: 16 }}>
      <div
        onClick={() => setOpen(o => !o)}
        style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', userSelect: 'none' }}
      >
        <DownOutlined
          style={{
            fontSize: 10,
            color: 'rgba(0, 0, 0, 0.45)',
            transform: open ? 'rotate(0deg)' : 'rotate(-90deg)',
            transition: 'transform 0.2s',
          }}
        />
        <span style={{ whiteSpace: 'nowrap', color: 'rgba(0, 0, 0, 0.88)', fontWeight: 500 }}>{title}</span>
        <span style={{ flex: 1, borderTop: '1px solid rgba(5, 5, 5, 0.06)' }} />
        {extra && (
          <span onClick={e => e.stopPropagation()} style={{ display: 'inline-flex' }}>
            {extra}
          </span>
        )}
      </div>
      {open && <div style={{ marginTop: 12 }}>{children}</div>}
    </div>
  );
};

export default CardSection;
